import React, { useState, useRef } from 'react';
import { Play, Pause } from 'lucide-react';

interface VoicePreviewProps {
  audioUrl: string;
  label?: string;
}

export function VoicePreview({ audioUrl, label }: VoicePreviewProps) {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  const togglePlay = () => {
    if (!audioRef.current) return;
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={togglePlay}
        className="p-2 rounded-full bg-blue-100 text-blue-600 hover:bg-blue-200 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
      >
        {isPlaying ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
      </button>
      {label && <span className="text-sm text-slate-600">{label}</span>}
      <audio
        ref={audioRef}
        src={audioUrl}
        onEnded={() => setIsPlaying(false)}
      />
    </div>
  );
}
